<template>
    <div class="product-list-item">
        <div class="product-list-column details">
            <div class="product-detail">
                <span class="wrapper">
                    <span class="product-name">{{ name || 'N/A' }}</span>
                    <span class="product-variation">({{ variation || 'N/A' }})</span>
                </span>
                <span class="product-quantity">x{{ quantity || 'N/A' }} {{ quantityLabelPart }}</span>
            </div>
        </div>
        <div class="product-list-column actions">
            <button type="button" class="action-button edit" @click.prevent="edit">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-edit">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                </svg>
            </button>
            <button type="button" class="action-button remove" @click.prevent="remove">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-x-circle">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="15" y1="9" x2="9" y2="15"></line>
                    <line x1="9" y1="9" x2="15" y2="15"></line>
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
export default {
	name: "product-list-item",
	props: {
		name: {
			type: String,
			required: true,
		},
		quantity: {
			required: true,
		},
		quantityType: {
			type: String,
			required: true,
		},
		variation: {
			type: String,
			required: true,
		},
		index: {
			type: Number,
			required: true,
		},
	},
	computed: {
		quantityLabelPart: function () {
			if (this.quantityType === "single") {
				return "Single Item(s)";
			}
			if (this.quantityType === "sqm") {
				return "Square Meters (m²)";
			}
			if (this.quantityType === "cubic") {
				return "Cubic Meters (m³)";
			}
			return "N/A";
		},
	},
	methods: {
		remove() {
			this.$emit("onRemove", this.index);
		},
		edit() {
			this.$emit("onEdit", this.index);
		},
	},
};
</script>

<style lang="scss" scoped>
.product-list-item {
    display: flex;
    width: 100%;

    .product-list-column {
        height: 48px;
        background-color: #efefef;
        display: flex;
        align-items: center;
        flex-flow: row nowrap;

        @media only screen and (max-width: 768px) {
            height: auto;
            min-height: 64px;
        }

        &.details {
            flex-grow: 1;
            margin-right: 10px;
            .product-detail {
                padding: 0 20px;
                display: flex;
                justify-content: space-between;
                width: 100%;

                @media only screen and (max-width: 768px) {
                    flex-flow: row wrap;
                }
                span {
                    display: inline-block;
                }
                .product-name {
                    font-weight: 700;
                }
                .product-variation {
                    font-style: italic;
                    margin-left: 6px;
                }
                .product-quantity {
                    opacity: 0.65;
                }
            }
        }

        &.actions {
            flex-grow: 0;
            padding: 0 8px;
            .action-button {
                display: flex;
                width: 36px;
                height: 36px;
                align-items: center;
                justify-content: center;
                border: none;
                cursor: pointer;
                outline: none;
                color: #a7a7a7;
                transition: color 100ms ease-out;
                background-color: transparent !important;
                padding: 0 !important;

                svg {
                    width: 21px;
                }

                &.edit {
                    color: $cl-primary;
                }

                &:hover {
                    color: $cl-primary-hover;
                }
            }
        }
    }
}
</style>